import React, { FC } from "react";
import { Button, Paper, Stack, useTheme } from "@mui/material";

import { CgNotes } from "react-icons/cg";
import { NewChatIcon } from "../../../icons";

import MarkdownRenderer from "../../../ui/MarkdownRenderer";
import Avatar from "../../../ui/Avatar";
import Row from "../../../ui/core/Row";

interface ContextWarningMessageBoxProps {
  text: string;
  onSummarize?: () => void;
  onNewChat?: () => void;
  showButtons?: boolean; // Whether to show the action buttons
}

const ContextWarningMessageBox: FC<ContextWarningMessageBoxProps> = ({
  text,
  onSummarize,
  onNewChat,
  showButtons = true,
}) => {
  const theme = useTheme();
  const Summarize = CgNotes as any;

  const handleSummarize = () => {
    if (onSummarize) {
      onSummarize();
    }
  };

  const handleNewChat = () => {
    if (onNewChat) {
      onNewChat();
    }
  };

  return (
    <Row
      sx={{
        alignItems: "flex-end",
        width: "100%",
        justifyContent: "flex-start",
        gap: 2,
        maxWidth: "60rem",
        marginRight: "auto",
        marginLeft: "auto",
        paddingBottom: "25px",
      }}
    >
      <Avatar sender="other" agentName={"other"} />

      <Paper
        elevation={0}
        sx={{
          whiteSpace: "pre-line",
          display: "flex",
          p: 1.5,
          px: 2,
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 1.25,
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`,
          bgcolor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          fontFamily: theme.typography.fontFamily,
          fontSize: "0.875rem",
          fontWeight: 500,
          lineHeight: "140%",
          maxWidth: "50rem",
          position: "relative",
        }}
      >
        <Stack direction="column" spacing={2} sx={{ flexWrap: "wrap" }}>
          {text && <MarkdownRenderer content={text} />}

          {showButtons && (
            <Row sx={{ gap: 1, justifyContent: "center", padding: 2 }}>
              <Button
                size="large"
                variant="contained"
                color="primary"
                sx={{ width: "200px" }}
                startIcon={<NewChatIcon />}
                onClick={handleNewChat}
              >
                Start a new chat
              </Button>

              <Button
                size="large"
                variant="outlined"
                color="primary"
                sx={{ width: "200px" }}
                startIcon={<Summarize />}
                onClick={handleSummarize}
              >
                Summarize
              </Button>
            </Row>
          )}
        </Stack>
      </Paper>
    </Row>
  );
};

export default ContextWarningMessageBox;
